import Seo from "@/components/Seo";
import { PageHero } from "@/components/Shared";

const Section = ({ titre, children }) => (
  <div className="mb-12">
    <h2 className="font-serif text-2xl text-marine mb-4">{titre}</h2>
    <div className="font-sans text-[15px] text-marine/80 leading-[1.8] space-y-3">{children}</div>
  </div>
);

export default function Confidentialite() {
  return (
    <div data-testid="page-confidentialite">
      <Seo
        title="Politique de confidentialité — Form Action Pro"
        description="Politique de confidentialité de formactionpro.net : données collectées via le formulaire de contact, finalités, durée de conservation, droits RGPD."
        path="/confidentialite"
      />
      <PageHero kicker="Vos données" title="Politique de confidentialité" />

      <section className="bg-white py-16">
        <div className="max-w-3xl mx-auto px-6">
          <Section titre="Responsable de traitement">
            <p>
              Form Action Pro — François Schoonheere, La Croix Valmer (Var), joignable à{" "}
              <a href="mailto:form.action1pro@gmail.com" className="text-vert-dark hover:underline">
                form.action1pro@gmail.com
              </a>{" "}
              ou au 07 69 05 76 73.
            </p>
          </Section>

          <Section titre="Données collectées">
            <p>
              Le seul traitement de données personnelles de ce site est le formulaire de contact.
              Les données recueillies sont : nom, structure, adresse e-mail, numéro de téléphone,
              besoin exprimé, contenu du message, et — si vous la cochez — l’indication d’une
              situation de handicap, destinée exclusivement à adapter les conditions de formation.
            </p>
          </Section>

          <Section titre="Finalités et base légale">
            <p>
              Ces données servent uniquement à répondre à votre demande, à établir un devis et à
              organiser une éventuelle prestation (mesures précontractuelles, article 6.1.b du
              RGPD). Elles ne sont utilisées à aucune autre fin, notamment commerciale.
            </p>
          </Section>

          <Section titre="Destinataires et durée de conservation">
            <p>
              Les données sont destinées exclusivement à Form Action Pro. Elles ne sont ni cédées,
              ni vendues à des tiers. Elles sont conservées au maximum 3 ans à compter du dernier
              échange, sauf obligation légale contraire.
            </p>
          </Section>

          <Section titre="Vos droits">
            <p>
              Vous disposez d’un droit d’accès, de rectification, d’effacement, de limitation, de
              portabilité et d’opposition concernant vos données. Pour l’exercer, écrivez à{" "}
              <a href="mailto:form.action1pro@gmail.com" className="text-vert-dark hover:underline">
                form.action1pro@gmail.com
              </a>
              . Vous pouvez également introduire une réclamation auprès de la CNIL (cnil.fr).
            </p>
          </Section>

          <Section titre="Cookies et mesure d’audience">
            <p>
              Ce site ne dépose aucun cookie publicitaire ni cookie de suivi nominatif. Seuls des
              éléments techniques strictement nécessaires au fonctionnement du site peuvent être
              utilisés.
            </p>
          </Section>

          <Section titre="Sécurité">
            <p>
              Les demandes transmises via le formulaire sont stockées de manière sécurisée et ne
              sont accessibles qu’au responsable de traitement.
            </p>
          </Section>
        </div>
      </section>
    </div>
  );
}
